import gql from 'graphql-tag';

export const DeleteAccidentIssueDocument = gql`
  mutation DeleteAccidentIssueDocumentBulk($input: DeleteAccidentIssueDocumentBulkInput!) {
    deleteAccidentIssueDocumentBulk(input: $input) {
      deleted
    }
  }
`;
